function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { TextField } from '../TextField';

var SelectFieldComponent = function SelectFieldComponent(_ref) {
  var _classnames3, _classnames5, _classnames8;

  var _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'default' : _ref$buttonType,
      children = _ref.children,
      classes = _ref.classes,
      disabled = _ref.disabled,
      display = _ref.display,
      InputProps = _ref.InputProps,
      raw = _ref.raw,
      select = _ref.select,
      SelectProps = _ref.SelectProps,
      props = _objectWithoutProperties(_ref, ["buttonType", "children", "classes", "disabled", "display", "InputProps", "raw", "select", "SelectProps"]);

  var internalInputProps = _objectSpread({}, InputProps);

  var internalSelectProps = _objectSpread({
    classes: {
      root: classnames(_defineProperty({}, classes.noIcon, display)),
      icon: classnames(_defineProperty({}, classes.disabledColor, disabled))
    }
  }, SelectProps);

  internalSelectProps["native"] = internalSelectProps["native"] ? internalSelectProps["native"] : false;
  var internalRawProp = raw;

  switch (buttonType) {
    case 'large':
      internalRawProp = true;
      internalInputProps = _objectSpread(_objectSpread({}, internalInputProps), {}, {
        classes: {
          input: classnames(classes.largeInput, (_classnames3 = {}, _defineProperty(_classnames3, classes.largeInputDisplay, !display), _defineProperty(_classnames3, classes.disabledBackground, disabled), _defineProperty(_classnames3, classes.disabledColor, disabled), _classnames3)),
          root: classnames(classes.root, _defineProperty({}, classes.noIcon, display)),
          focused: classes.focused
        },
        disableUnderline: true
      });
      internalSelectProps = _objectSpread(_objectSpread({}, internalSelectProps), {}, {
        classes: {
          select: classnames(classes.select),
          icon: classnames(classes.largeIcon)
        }
      });
      break;

    case 'small':
      internalRawProp = true;
      internalInputProps = _objectSpread(_objectSpread({}, internalInputProps), {}, {
        classes: {
          input: classnames(classes.smallInput, (_classnames5 = {}, _defineProperty(_classnames5, classes.disabledBackground, disabled), _defineProperty(_classnames5, classes.disabledColor, disabled), _classnames5)),
          root: classnames(classes.root, _defineProperty({}, classes.noIcon, display)),
          focused: classes.focused
        },
        disableUnderline: true
      });
      internalSelectProps = _objectSpread(_objectSpread({}, internalSelectProps), {}, {
        classes: {
          select: classnames(classes.select),
          icon: classnames(classes.smallIcon, _defineProperty({}, classes.disabledColor, disabled))
        }
      });
      break;

    case 'uppercase':
      internalRawProp = true;
      internalInputProps = _objectSpread(_objectSpread({}, internalInputProps), {}, {
        classes: {
          input: classnames((_classnames8 = {}, _defineProperty(_classnames8, classes.uppercaseInput, !display), _defineProperty(_classnames8, classes.disabledBackground, disabled), _defineProperty(_classnames8, classes.disabledColor, disabled), _classnames8)),
          root: classnames(classes.root, _defineProperty({}, classes.noIcon, display)),
          focused: classes.focused
        },
        disableUnderline: true
      });
      internalSelectProps = _objectSpread(_objectSpread({}, internalSelectProps), {}, {
        classes: {
          select: classnames(classes.uppercaseSelect),
          icon: classnames(classes.uppercaseIcon, _defineProperty({}, classes.disabledColor, disabled))
        }
      });
      break;

    default:
      break;
  }

  return (
    /*#__PURE__*/
    React.createElement(TextField, _extends({
      disabled: disabled,
      display: display,
      InputProps: internalInputProps,
      raw: internalRawProp,
      select: true,
      SelectProps: internalSelectProps
    }, props), children)
  );
};

var styles = function styles(theme) {
  var select = {
    paddingRight: 24,
    minWidth: 0,
    '&:focus': {
      backgroundColor: 'transparent'
    }
  };
  return {
    select: _objectSpread({}, select),
    uppercaseSelect: _objectSpread({
      paddingTop: 4,
      paddingBottom: 4
    }, select),
    root: {
      borderColor: 'transparent',
      backgroundColor: 'transparent',
      '&$focused': {
        borderColor: 'transparent'
      }
    },
    smallInput: _objectSpread(_objectSpread({}, theme.typography.body2), {}, {
      color: theme.palette.primary.main
    }),
    largeInput: _objectSpread({}, theme.typography.h6),
    largeInputDisplay: {
      color: theme.palette.primary.main
    },
    uppercaseInput: _objectSpread(_objectSpread({}, theme.typography.button), {}, {
      color: theme.palette.primary.main
    }),
    smallIcon: {
      color: theme.palette.primary.main
    },
    largeIcon: {
      color: theme.palette.primary.main
    },
    uppercaseIcon: {
      right: -4,
      color: theme.palette.primary.main
    },
    disabledBackground: {
      backgroundColor: 'transparent'
    },
    noIcon: {
      '& svg': {
        display: 'none'
      },
      '& div': {
        paddingRight: 4
      }
    },
    disabledColor: {
      color: theme.palette.grey[600]
    },
    focus: {},
    focused: {}
  };
};

export var SelectField = withStyles(styles)(SelectFieldComponent);
SelectField.dsuiName = 'SelectField';